import { create } from 'zustand';

/**
 * Globale store voor de order-detail drawer. Mirror van
 * wasserij-item-drawer-store. Geen URL-sync in fase 1; direct-link naar een
 * order blijft werken via de bestaande /orders/:id route.
 */
interface OrderDetailDrawerState {
  openOrderId: string | null;
  open: (id: string) => void;
  close: () => void;
}

export const useOrderDetailDrawerStore = create<OrderDetailDrawerState>((set) => ({
  openOrderId: null,
  open: (id) => set({ openOrderId: id }),
  close: () => set({ openOrderId: null }),
}));
